import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../../../atoms';

FindYourDocumentLink.propTypes = {
  incomingPayment: PropTypes.instanceOf(Object).isRequired,
};

export function FindYourDocumentLink({ incomingPayment }) {
  const shouldHideLink = incomingPayment?.ui?.disable_find_your_document_link;

  if (shouldHideLink) {
    return null;
  }

  return (
    <div style={{ position: 'absolute', top: '0', right: '0' }}>
      <Link href="http://buscardatos.com/Personas/Apellido/">
        Descubre tu documento
      </Link>
    </div>
  );
}
